import { h } from 'preact'

export default () => (<svg class='topic-view_sticky-flag' width='14' height='18' viewBox='0 0 14 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M14 0H0V18L7 15L14 18V0Z' fill='#0069FF' />
</svg>)
